import { useEffect, useState } from 'react';

export type PlatformType = 'mobile' | 'desktop';

export const usePlatform = (): PlatformType => {
  const [platform, setPlatform] = useState<PlatformType>(() =>
    window.innerWidth < 768 ? 'mobile' : 'desktop'
  );

  useEffect(() => {
    const handleResize = () => {
      setPlatform(window.innerWidth < 768 ? 'mobile' : 'desktop');
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return platform;
};
